<template>
  <vs-popup class="add-additional-cost-popup"
            id="popup"
            :title="`Remove SOS`"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          
          <!-- Who is authorising this SOS to be removed? -->
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <ValidationProvider name="authoriser" rules="required" v-slot="{ errors }">
                <v-select
                  v-model="formData.authoriser_id"
                  :options="authorisedUsers"
                  :reduce="user => user.id"
                  label="name"
                  placeholder="Who is authorising this SOS to be removed?"
                  class="w-full"
                  :class="{ 'error': errors.length > 0 }"
                />
                <span class="text-danger text-sm" v-if="errors[0]">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Reason for change -->
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <ValidationProvider name="reason" rules="required" v-slot="{ errors }">
                <v-select
                  v-model="formData.reason_id"
                  :options="changeReasons"
                  :reduce="reason => reason.id"
                  label="reason"
                  placeholder="Reason for change"
                  class="w-full"
                  :class="{ 'error': errors.length > 0 }"
                />
                <span class="text-danger text-sm" v-if="errors[0]">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Notes for user to capture when and how -->
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <ValidationProvider name="notes" rules="" v-slot="{ errors }">
                <vs-textarea
                  v-model="formData.notes"
                  label="Notes (capture when and how)"
                  class="w-full"
                  rows="4"
                  :danger="errors.length > 0"
                />
                <span class="text-danger text-sm" v-if="errors[0]">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="vx-row">
            <div class="vx-col w-full flex justify-end">
              <vs-button 
                color="danger" 
                type="border" 
                class="mr-3"
                @click="open = false"
              >
                Cancel
              </vs-button>
              <vs-button 
                color="primary" 
                type="filled"
                button="submit"
              >
                Remove SOS
              </vs-button>
            </div>
          </div>

        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const CustomerRepository = RepositoryFactory.get('customer')
const DropdownRepository = RepositoryFactory.get('drop_down')
import vSelect from 'vue-select'

export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'v-select': vSelect
  },
  data() {
    return {
      open: false,
      formData: {
        sosId: null,
        authoriser_id: null,
        reason_id: null,
        notes: ''
      },
      authorisedUsers: [],
      changeReasons: []
    }
  },
  watch: {
    active(val) {
      this.open = val
    }
  },
  mounted() {
 
  },
  methods: {
    openPopup(id) {
      this.open = true
      this.sosId = id;
      this.fetchAuthorisedUsers()
      this.fetchChangeReasons()
    },
    async fetchChangeReasons() {
      try {
        const response = await CustomerRepository.getSosChangeReasons({
          'filter[reason]': ''
        })
        this.changeReasons = response.data.data
      } catch (error) {
        console.error('Error fetching change reasons:', error)
      }
    },
    async fetchAuthorisedUsers() {
      try {
        const response = await DropdownRepository.getStaffAccountHandlers()
        this.authorisedUsers = response.data.data
      } catch (error) {
        console.error('Error fetching authorised users:', error)
      }
    },
    async onSubmit() {
      this.$emit('submit', {
        sosId: this.sosId,
        authoriser_id: this.formData.authoriser_id,
        reason_id: this.formData.reason_id,
        notes: this.formData.notes
      })
      
      this.open = false
      this.resetForm()
    },
    resetForm() {
      this.formData = {
        authoriser_id: null,
        reason_id: null,
        notes: ''
      }
      this.$refs.form.reset()
    }
  }
}
</script>